export { StandardProductDetails } from "./StandardProductDetails";
